import type { IconName } from '@iconik-io/uad';

import type { MediaType } from './media_type';

export const mediaTypeIcon: { [mediaType in MediaType]: IconName } = {
  image: 'asset_type_image',
  audio: 'asset_type_audio',
  video: 'asset_type_video',
  stream: 'asset_type_video',
  pdf: 'asset_type_pdf',
  placeholder: 'asset_type_placeholder',
  collection: 'collection',
  collection_isg: 'isg',
  sequence: 'sequence',
  nle_project: 'project',
  custom: 'file',
  file: 'file',
  link: 'link',
  subclip: 'asset_type_subclip',
  playlist: 'playlist',
  post: 'send',
};

// Wide on purpose: callers test raw values coming off the API. mediaTypeIcon is
// a closed literal keyed by MediaType, so membership proves the narrowing.
export const mediaTypes: ReadonlySet<string> = new Set(
  Object.keys(mediaTypeIcon),
);

export const isMediaType = (value: string): value is MediaType =>
  mediaTypes.has(value);
